import { useState } from 'react';
import DeleteDialog from '../dialogs/DeleteDialog';
import TrashNote from '../../assets/icons/trash.svg';

const TrashButton = ({ cleanAll }: { cleanAll: () => void }) => {
    const [showDeleteDialog, setShowDeleteDialog] = useState<boolean>(false);

    return (
        <>
            <button
                className="bottom-action-button"
                onClick={() => {
                    cleanAll();
                    // setShowDeleteDialog(true);
                }}
            >
                <img src={TrashNote} alt="trash-note" />
            </button>

            <DeleteDialog show={showDeleteDialog} close={() => setShowDeleteDialog(false)} clearStaves={cleanAll}></DeleteDialog>
        </>
    );
};

export default TrashButton;
